<template>
  <div class="product" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          <template v-if="!data.product.id">
            {{ util.language('新增', 'New ') }}
          </template>
          <template v-else>
            {{ util.language('编辑', 'Edit ') }}
          </template>
          {{ util.language('商品', 'Product') }}
        </el-text>
        <el-button-group>
          <el-button @click="router.go(-1)">{{ util.language('返回', 'Back') }}</el-button>
          <el-button type="primary" @click="save()" :loading="loading.save">{{ util.language('保存', 'Save') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="ID" v-if="data.product.id">
        <el-input v-model="data.product.id" disabled />
      </el-form-item>
      <el-divider content-position="left">{{ util.language('商品基本信息', 'Base info of product') }}</el-divider>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="util.language('编码', 'Code')">
            <el-input v-model="data.product.code" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="util.language('类型', 'Type')">
            <el-select filterable clearable v-model="data.product.typeId" style="width: 100%;">
              <el-option v-for="item in show.productTypes" :key="item.id" :label="util.language(item.cnName, item.enName)" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item :label="util.language('图片', 'Image')">
        <el-image class="avatar-uploaded" v-if="data.product.img" :src="data.product.img" :preview-src-list="[data.product.img]" fit="cover" />
        <el-upload class="avatar-uploader" :action="api.baseURL() + '/backend/file/upload'" :headers="api.tokenHeader()" :show-file-list="false" :on-success="productUploadSuccess" :before-upload="beforeProductUpload">
          <el-icon v-if="data.product.img" class="avatar-uploader-icon">
            <RefreshRight />
          </el-icon>
          <el-icon v-else class="avatar-uploader-icon">
            <Plus />
          </el-icon>
        </el-upload>
      </el-form-item>
      <el-form-item :label="util.language('英文名', 'English name')">
        <el-input v-model="data.product.enName" />
      </el-form-item>
      <el-form-item :label="util.language('中文名', 'Chinese name')">
        <el-input v-model="data.product.cnName" />
      </el-form-item>
      <el-form-item :label="util.language('商品描述', 'Description')">
        <el-input v-model="data.product.note" />
      </el-form-item>
      <el-form-item :label="util.language('内部备注', 'Insider note')">
        <el-input type="textarea" :rows="3" v-model="data.product.insiderNote" />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="util.language('销售方式', 'Sale mode')">
            <el-select clearable v-model="data.product.hasUnit" style="width: 100%;">
              <el-option :key="true" :label="util.language('按单位（称重）', 'Unit(Weigh)')" :value="true" />
              <el-option :key="false" :label="util.language('按件', 'Piece')" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="util.language('单位', 'Unit')">
            <el-select clearable v-model="data.product.unit" style="width: 100%;">
              <el-option key="KG" :label="util.language('千克', 'KG')" value="KG" />
              <el-option key="LB" :label="util.language('磅', 'LB')" value="LB" />
              <el-option key="OZ" :label="util.language('盎司', 'OZ')" value="OZ" />
              <el-option key="ML" :label="util.language('毫升', 'ML')" value="ML" />
              <el-option key="UNIT" :label="util.language('个', 'Unit')" value="UNIT" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="util.language('销售单元', 'Sale unit')">
            <el-input-number style="width: calc(100% - 120px);" :precision="2" :controls="false" :min="0" v-model="data.product.unitPerPiece" />
            <el-text style="margin-left: 5px;">{{ data.product.unit }} /{{ util.language('件', 'piece') }}</el-text>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="util.language('税', 'Tax')">
            <el-select clearable v-model="data.product.hasTax" style="width: 100%;">
              <el-option :key="true" :label="util.language('需要税', 'Has tax')" :value="true" />
              <el-option :key="false" :label="util.language('免税', 'No tax')" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="shopId">
        <el-divider content-position="left">
          <el-switch v-model="data.editProdcutInShop" :inactive-text="util.language('不设置', 'Not set')" :active-text="util.language('店铺内商品信息', 'Info in shop')" />
        </el-divider>
        <el-row :gutter="20" v-show="data.editProdcutInShop">
          <el-col :span="12">
            <el-form-item :label="util.language('排序', 'Sort')">
              <el-input-number style="width: 100%;" v-model="data.product.orderBy" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="util.language('状态', 'State')">
              <el-select clearable v-model="data.product.enable" style="width: 100%;">
                <el-option :key="true" :label="util.language('启用', 'Enable')" :value="true" />
                <el-option :key="false" :label="util.language('停用', 'Disable')" :value="false" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="util.language('库存件数', 'Inventory QTY')">
              <el-input-number v-if="!data.product.id || !data.product.shopId" style="width: 100%;" :precision="0" :controls="false" :min="0" v-model="data.product.pieceInventoryQuantity" />
              <template v-else>
                <el-input style="width: calc(100% - 200px);" disabled v-model="data.product.pieceInventoryQuantity" />
                <el-link style="margin-left: 20px; width: 80px;" v-if="data.product.pieceInventoryQuantity !== undefined" @click="show.editingInventory = true">{{ util.language('编辑库存', 'Edit') }}</el-link>
                <el-link style="margin-left: 20px; width: 80px;" v-if="data.product.pieceInventoryQuantity !== undefined" @click="inventoryHistory()">{{ util.language('库存历史', 'History') }}</el-link>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
          <el-col :span="12">
            <el-form-item :label="util.language('售价', 'Sale price')">
              <el-input-number style="width: calc(100% - 120px);" :precision="2" :controls="false" :min="0" v-model="data.product.unitPrice" />
              <el-text style="margin-left: 5px;">/{{ data.product.unit }}</el-text>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="util.language('进价', 'Purchase price')">
              <el-input-number style="width: calc(100% - 120px);" :precision="2" :controls="false" :min="0" v-model="data.product.unitPriceIn" />
              <el-text style="margin-left: 5px;">/{{ data.product.unit }}</el-text>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>
    <div style="height: 10px;"></div>
  </div>

  <el-dialog v-model="show.editingInventory" :title="util.language('编辑库存', 'Edit inventory')" width="700">
    <el-text>{{ util.language('库存调整：', 'Inventory adjustment: ') }}</el-text>
    <el-input-number style="width: 150px" :precision="0" v-model="data.changeInventory.quantity" @change="changeInventoryQuantity" />
    <el-text>{{ util.language('件。', 'piece. ') }}</el-text>
    <el-text>{{ util.language('预期调整后：', 'Expected adjustment to ') }}</el-text>
    <el-text style="color: #000; font-weight: bolder;">{{ math.plus(data.product.pieceInventoryQuantity, data.changeInventory.quantity) }}</el-text>
    <el-text>{{ util.language(' 件。', ' piece. ') }}</el-text>
    <br />
    <br />
    <el-text>{{ util.language('库存进价：', 'Inventory purchase price: ') }}</el-text>
    <el-input-number :controls="false" style="width: 100px" :precision="2" v-model="data.changeInventory.unitPriceIn" />
    <el-text style="margin-left: 5px;">/{{ data.product.unit }}</el-text>
    <el-text>{{ util.language('，总计单位数量（总重）：', ', sum unit quantity (weight): ') }}</el-text>
    <el-input-number :controls="false" style="width: 100px" :precision="2" v-model="data.changeInventory.unitQuantity" />
    <el-text style="margin-left: 5px;">{{ data.product.unit }}</el-text>
    <br />
    <br />
    <template v-if="util.language() === 'cn'">
      <el-text type="info">库存调整说明：</el-text>
      <br />
      <el-text type="info">1. 填写正数，增加库存；填写负数，减少库存。</el-text>
      <br />
      <el-text type="info">2. 库存最多减少到0。</el-text>
      <br />
      <el-text type="info">3. 实际调整只按变化量调整。调整时，有其他人在进行出入库操作，结果和预期会有偏差。</el-text>
      <br />
      <el-text type="info">4. 进价、重量会保存在库存调整记录中，供综合调整进价、售价做参考。</el-text>
    </template>
    <template v-else-if="util.language() === 'en'">
      <el-text type="info">Tips:</el-text>
      <br />
      <el-text type="info">1. Fill in positive numbers to increase inventory, Fill in negative numbers to reduce inventory.</el-text>
      <br />
      <el-text type="info">2. Inventory can be reduced to a maximum of 0.</el-text>
      <br />
      <el-text type="info">3. The actual adjustment is only based on the amount of change. When adjusting, there may be deviations from expectations due to other people performing inbound and outbound operations.</el-text>
      <br />
      <el-text type="info">4. The purchase price\weight will be saved in the inventory adjustment record for reference when adjusting the purchase price and selling price.</el-text>
    </template>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="show.editingInventory = false">{{ util.language('取消', 'Cancel') }}</el-button>
        <el-button type="primary" @click="submitEditingInventoryQuantity" :loading="loading.editingInventory">{{ util.language('确认调整', 'OK') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const shopId = cache.getObject(cache.keys.shopId)
if (!shopId) {
  ElMessage.error(util.language('请先选择店铺', 'Please select a shop first'))
}
const show = reactive({
  productTypes: [],
  editingInventory: false,
})
const loading = reactive({
  save: false,
  editingInventory: false,
})
const pageParam = cache.getObject(cache.keys.pageParam + "product")
const data = reactive({
  product: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {},
  editProdcutInShop: true,
  changeInventory: {
    quantity: 0,
    unitPriceIn: 0,
    unitQuantity: 0,
  }
})
api.get('/backend/product/getProductType').then(res => {
  show.productTypes = res.list
})

/** 商品图片上传前 */
const beforeProductUpload = (rawFile) => {
  if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png') {
    ElMessage.error(util.language('仅支持上传jpg、png格式的图片', 'Only jpg, png images are supported'))
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error(util.language('仅支持上传2M以内的图片', 'Only images under 2M are supported'))
    return false
  }
  return true
}

/** 商品图片上传成功 */
const productUploadSuccess = (response, uploadFile) => {
  if (response.code === 'S000001') {
    data.product.img = response.data.path
    ElMessage.warning(util.language('上传成功，请注意保存', 'Upload successful, please save'))
  } else {
    ElMessage.error(response.msg || util.language('上传失败', 'Upload failed'))
  }
}

const save = () => {
  loading.save = true
  const product = {
    typeId: data.product.typeId,
    img: data.product.img || '',
    enName: data.product.enName,
    cnName: data.product.cnName,
    note: data.product.note || '',
    insiderNote: data.product.insiderNote || '',
    hasUnit: data.product.hasUnit,
    hasTax: data.product.hasTax,
    unit: data.product.unit,
    unitPerPiece: data.product.unitPerPiece,
  }
  let productShop = data.editProdcutInShop ? {
    shopId: shopId,
    orderBy: data.product.orderBy,
    enable: data.product.enable,
    unitPriceIn: data.product.unitPriceIn,
    unitPrice: data.product.unitPrice,
    pieceInventoryQuantity: data.product.pieceInventoryQuantity,
  } : null
  if (!data.product.id) {
    product.code = data.product.code
    api.post('/backend/product/addProduct', {
      product: product,
      productShop: productShop || null,
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  } else {
    product.id = data.product.id
    api.post('/backend/product/setProduct', {
      product: product,
      productShop: productShop || null,
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  }
}

const submitEditingInventoryQuantity = () => {
  if (!data.changeInventory.quantity) {
    ElMessage.warning(util.language('请输入数量', 'Please enter the quantity'))
    return
  }
  data.changeInventory.unitPriceIn = data.changeInventory.unitPriceIn || 0
  data.changeInventory.unitQuantity = data.changeInventory.unitQuantity || 0
  loading.editingInventory = true
  api.post('/backend/product/setInventoryQuantity', {
    shopId: shopId,
    productId: data.product.id,
    changeQuantity: data.changeInventory.quantity,
    unitPriceIn: data.changeInventory.unitPriceIn,
    unitQuantity: data.changeInventory.unitQuantity,
  }).then(res => {
    data.changeInventory = {
      quantity: 0,
      unitPriceIn: 0,
      unitQuantity: 0,
    }
    show.editingInventory = false
    ElMessage.success(util.language('修改成功', 'Success'))
    data.product.pieceInventoryQuantity = res.toQuantity
  }).finally(() => {
    loading.editingInventory = false
  })
}

/** 修改库存变化数 */
const changeInventoryQuantity = (value) => {
  value = value || 0
  data.changeInventory.unitQuantity = math.multiply(value, data.product.unitPerPiece)
}

/** 库存历史 */
const inventoryHistory = () => {
  const inventoryHistoriesParam = {
    productCode: data.product.code,
    operate: 'BACKEND',
  }
  cache.setObject(cache.keys.pageParam + 'inventoryHistories', inventoryHistoriesParam)
  router.push('/inventoryHistories')
}
</script>

<style lang="less">
.product {
  margin: auto;
  max-width: 900px;

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>